<template>
  <div class="tab-warpper">
    <div v-for="item in list_data" :key="item.index">
      <el-card class="box-card">
        <div slot="header" class="hd">
          <div class="left_tab">
            <span>患者:</span>
            <span>{{ item.patientName }}</span>
          </div>
          <div class="right_tab">
            <span class="right_tab_wait">{{
              ORDER_STATUS[item.statusName]
            }}</span>
          </div>
        </div>
        <div class="content">
          <div class="c_item">
            <span>来自:</span>
            <span>{{ item.channelName }}</span>
          </div>
          <div class="c_item">
            <span>所属科室:</span>
            <span>{{ item.departmentName }}</span>
          </div>
          <div class="c_item">
            <span>年龄:</span>
            <span>{{ item.patientAge }}</span>
          </div>
          <div class="c_item">
            <span>预约时间:</span>
            <span v-if="item.channelCode != 'budan'"
              >{{ item.scheduleDate }}&nbsp;&nbsp;{{ item.schedulePeriodStart }} - {{
                item.schedulePeriodEnd
              }}</span
            >
            <span v-else> {{ item.createTime }} </span>
          </div>
        </div>
        <div class="footer">
          <!-- <el-button
            type="primary"
            v-show="item.is_eye_department == 1 && item.is_have_report != 1"
            size="mini"
            @click="checkSlice(item)"
          >查看阅片</el-button>-->
          <!-- <el-button
            type="primary"
            v-show="item.is_eye_department == 1 && item.is_have_report == 1"
            size="mini"
            @click="toReport()"
            >预览报告</el-button
          > -->

          <!-- 乐荐退费功能隐藏 -->
          <!-- <el-button
            type="success"
            size="mini"
            v-if="item.orderTreatStatus == -1"
            @click="onMoneyBack(item.id)"
            >立即退费</el-button
          > -->
          <el-button
            type="primary"
            size="mini"
            v-if="item.status == 10006"
            @click="handleRefundRequestDia(item)"
            >退款请求</el-button
          >
          <el-button type="primary" size="mini" @click="detailHandle(item)"
            >查看详情</el-button
          >
          <el-button type="info" size="mini" @click="patientsHandle(item)"
            >查看病历</el-button
          >
        </div>
      </el-card>
    </div>
    <div v-if="list_data.length == 0" class="empty">
      <emptyData />
    </div>
    <money-back-popup ref="popup" @success="popupSuccess"></money-back-popup>
    <!-- 退款请求 -->
    <el-dialog title="退款请求" :visible.sync="refundRequestDia" width="30%">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="退款人：" prop="name">
          {{ ruleForm.patientName }}
        </el-form-item>
        <el-form-item label="退款原因：" prop="resource">
          {{ ruleForm.tag }}
        </el-form-item>
        <el-form-item label="原因描述：" prop="desc">
          {{ ruleForm.cause }}
        </el-form-item>
        <el-form-item label="退款方式：" prop="desc"> 原支付返还 </el-form-item>
        <el-form-item label="退款金额：" prop="desc">
          ￥{{ ruleForm.payMoney || 0 }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailHandle(ruleForm)">咨询记录</el-button>
        <el-button @click="reportPatient">举报患者</el-button>
        <!-- <el-button @click="dialogVisible = false">拒绝退款</el-button> -->
        <el-button type="primary" @click="setRefundCancel">同意退款</el-button>
      </span>
    </el-dialog>
    <AdverseEvent
      :centerDialogVisible="centerDialogVisible"
      :treatId="ruleForm.orderNo"
    />
    <UserInfo
      :centerDialogVisible="userDialogVisible"
      :userPhone="orderInfo.patientMobile"
      :orderNo="orderInfo.orderNo"
      :patientId="orderInfo.patientId"
      :patientName="orderInfo.patientName"
    />
  </div>
</template>

<script>
import util from "@/utils";
import { getRefundRemark,getOrderList } from "@/api";
import {  setRefundCancel } from "@/api/doctor.js";
import emptyData from "@/components/common/emptyData.vue";
import moneyBackPopup from "@/components/moneyBackPopup/index.vue";
import AdverseEvent from "@/components/common/AdverseEvent";
import UserInfo from "@/components/replenishment/userInfo";
import { ORDER_STATUS } from "@/utils/constants";

export default {
  name: "patients",
  components: { emptyData, moneyBackPopup, AdverseEvent, UserInfo },
  props: {},
  data() {
    return {
      ORDER_STATUS,
      orderInfo: {},
      centerDialogVisible: { value: false },
      userDialogVisible: { value: false },
      list_data: [],
      refundRequestDia: false,
      ruleForm: {
        tag: "",
        cause: "",
        payMoney: 0,
      },
    };
  },
  created() {
    const that = this;
    that.readyList();
  },
  filters: {
    getGender: function(value) {
      if (value) {
        return value.genderText;
      }
      return "性别保密";
    },
    getName: function(value) {
      if (value) {
        return value.name;
      }
      return "患者已删除";
    },
    getAge: function(value) {
      if (value) {
        return value.age;
      }
      return "保密";
    },
  },
  methods: {
    // 举报患者
    reportPatient() {
      this.centerDialogVisible.value = true;
    },
    // 退款请求
    handleRefundRequestDia(val) {
      this.ruleForm = val;
      this.getRefundRemark();
      this.refundRequestDia = true;
    },
    // 获取退款原因
    async getRefundRemark() {
      const params = {
        orderNo: this.ruleForm.orderNo,
      };
      const { data } = await getRefundRemark(params);
      this.$set(this.ruleForm, "cause", data.cause);
      this.$set(this.ruleForm, "tag", data.tag);
      this.$set(this.ruleForm, "payMoney", data.payMoney);
    },
    // 同意退款
    async setRefundCancel() {
      const params = {
        orderNo: this.ruleForm.orderNo,
      };
      const res = await setRefundCancel(params);
      if (res.code == 1) {
        this.refundRequestDia = false;
        this.readyList();
      }
    },
    // 患者列表
    async readyList() {
      const params = {
        status: 0,
        doctorId: util.getStore("user_id"),
        size: 10,
        current: 1,
        serviceId: 2,
      };
      let res = await getOrderList(params);
      if (res.code == 1) {
        this.list_data = res.data.records;
      }
    },

    //查看病历
    patientsHandle(item) {
      if (item.patientId == null || item.patientId == "") {
        this.$message({
          showClose: true,
          message: "该病历信息不存在或者已被删除",
          type: "error",
        });
        return;
      }
      let query = {
        casesId: item.patientId,
        orderNo: item.orderNo,
      };
      this.$router.push({
        path: "/index/work/patientDetails",
        query,
      });
    },
    //查看详情
    detailHandle(item) {
      this.orderInfo = item;
      if (item.channelCode != "budan") {
        if (!item.accid) {
          this.$message({
            showClose: true,
            message: "该会员信息已被删除,无法进行问诊",
            type: "error",
          });
          return;
        }
        let query = {
          sessionId: "p2p-" + item.accid,
          treatId: item.orderNo,
          patientId: item.patientId,
          status: item.status,
          doctorMobile: item.doctorMobile,
          patientName: item.patientName,
          memberId: item.memberId,
        };
        this.$router.push({
          path: "/index/work/chart",
          query,
        });
      } else {
        if (item.showType) {
          this.userDialogVisible.value = true;
        } else {
          const query = {
            sessionId: "p2p-" + 1111111,
            treatId: item.orderNo,
            patientId: item.patientId,
            status: 10002,
            type: "replenishment",
          };
          this.$router.push({
            path: "/index/work/chart",
            query,
          });
        }
      }
    },
    //打开立即退费弹窗
    onMoneyBack(id) {
      this.$refs["popup"].open(id);
    },
    //关闭退费弹窗
    onClosePopup() {
      this.$refs["popup"].close();
    },
    //退费成功后返回 逻辑改变状态
    popupSuccess(id) {
      this.list_data.forEach((e) => {
        if (e.id == id) {
          e.orderTreatStatus = 15;
          e.orderTreatStatus_dictText = "已退费";
        }
      });
    },
    //查看阅片
    checkSlice(item) {
      let query = {
        sickImId: item.imAccid,
        sickId: item.sick_id,
        casesId: item.cases_id,
        orderId: item.id,
        from: "work",
      };
      this.$router.push({
        path: "/index/work/slice",
        query,
      });
    },
    toReport(item) {
      this.$router.push({
        path: "/index/user/reportManage",
      });
    },
  },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.tab-warpper {
  .hd {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .right_tab {
      .right_tab_wait {
        color: #7d7979;
      }
      .right_tab_complete {
        color: #019e4e;
      }
    }
  }

  .content {
    line-height: 25px;
    margin: 5px 0;
    display: block;
    .c_item span {
      margin: 0 5px;
    }
  }

  .footer {
    border-top: 1px solid #ccc;
    padding: 5px 0;
    text-align: right;
  }
}
.empty {
  width: 50%;
  margin: 0 auto;
  margin-top: 50%;
}
</style>
